import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-awards-accolades',
  templateUrl: './awards-accolades.component.html',
  styleUrls: ['./awards-accolades.component.sass']
})
export class AwardsAccoladesComponent implements OnInit {

  @Output() userAwards = new EventEmitter<string[]>();

  @ViewChild('awardInput', { static: true }) awardInput: ElementRef<
    HTMLInputElement
  >;
  awards: Array<string>;
  awardsCtrl = new FormControl();
  constructor() { }

  ngOnInit(): void {
    this.awards = [];
  }

  enterAward(event) {

    const award = this.awardsCtrl.value;
    if (!this.awards.includes(award) && award !== null && award.length > 0) {
      this.awards.push(award);
    }

    this.awardInput.nativeElement.value = '';
    this.awardsCtrl.setValue(null);
    this.userAwards.emit(this.awards);
  }
  removeAward(link) {
    const index = this.awards.indexOf(link);
    if (index >= 0) {
      this.awards.splice(index, 1);
      this.userAwards.emit(this.awards);
    }
  }
}
